import React, { useState } from "react";
import { CheckCircle2 } from "lucide-react";
import "./contact.css";
import "./banner.css";
import API_ROUTES from "../components/config/apiConfig";

const Contact = () => {

  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState("");

  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    phone: "",
    address: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const res = await fetch(API_ROUTES.CREATE_ENQUIRY, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          name: formData.fullName,
          email: formData.email,
          phone: formData.phone,
          address: formData.address,
          message: formData.message,
        }),
      });

      const data = await res.json();

      if (data.success) {
        setSuccess(true);
        setFormData({ fullName: "", email: "", phone: "", address: "", message: "" });
        // 4 second baad success message hide karo
        setTimeout(() => setSuccess(false), 4000);
      } else {
        setError(data.message || "Something went wrong.");
      }
    } catch (err) {
      setError("Network error. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* Banner Section */}
      <section className="banner text-white py-5">
        <div className="container">
          <div className="row align-items-center">

            <div className="col-lg-5 text-center pt-5 mt-5 text-lg-start mb-4 mb-lg-0">
              <h1 className="display-5 fw-bold">
                Contact Us
              </h1>

              <p className="text-white-50">
                Get in touch with our team for any questions.
              </p>
            </div>

            <div className="col-lg-7 text-center">
              <img
                src="images/sofa21.png"
                alt="couch"
                className="img-fluid banner-img"
              />
            </div>

          </div>
        </div>
      </section>

      {/* Map Section */}
      <section className="map-section">
        <div className="container-fluid p-0">

          <iframe
            src="https://www.google.com/maps?q=PAAB%20Furniture%20Private%20Limited%20Sector%2080%20Noida&output=embed"
            width="100%"
            height="400"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            title="Paab Furniture Location"
          ></iframe>

        </div>
      </section>

      {/* Modern Contact Section */}
      <div className="contact-modern">

        <div className="container">

          <div className="row align-items-center">

            {/* LEFT SIDE CONTENT */}
            <div className="col-lg-6 mb-5 pe-lg-5">

              <h2 className="contact-heading">
                Talk to an <span>Expert</span> Today
              </h2>

              <p className="contact-sub">
                Get in touch with our team for any questions about our products.
              </p>

              <ul className="contact-features">

                <li>
                  <CheckCircle2
                    className="feat-icon"
                    size={20}
                  />

                  <div>
                    <strong>
                      Personalized Guidance from Experts
                    </strong>

                    <p>
                      Get direct access to interior design professionals.
                    </p>
                  </div>
                </li>

                <li>
                  <CheckCircle2
                    className="feat-icon"
                    size={20}
                  />

                  <div>
                    <strong>
                      Secure & Confidential Communication
                    </strong>

                    <p>
                      Your data is protected with high-grade security.
                    </p>
                  </div>
                </li>

                <li>
                  <CheckCircle2
                    className="feat-icon"
                    size={20}
                  />

                  <div>
                    <strong>
                      Fast & Friendly Support
                    </strong>

                    <p>
                      Our team is ready to assist you—expect quick responses.
                    </p>
                  </div>
                </li>

              </ul>

            </div>

            {/* RIGHT SIDE FORM CARD */}
            <div className="col-lg-6">

              <div className="contact-card">

                <h4 className="form-title">
                  Please enter your information
                </h4>

                <form onSubmit={handleSubmit}>

                  <div className="row g-3">

                    {/* FULL NAME */}
                    <div className="col-6">

                      <label className="label-tiny">
                        Full Name
                      </label>

                      <input
                        type="text"
                        name="fullName"
                        placeholder="Full Name"
                        className="form-control"
                        value={formData.fullName}
                        onChange={handleChange}
                        required
                      />

                    </div>

                    {/* EMAIL */}
                    <div className="col-6">

                      <label className="label-tiny">
                        Email
                      </label>

                      <input
                        type="email"
                        name="email"
                        placeholder="Email"
                        className="form-control"
                        value={formData.email}
                        onChange={handleChange}
                        required
                      />

                    </div>

                    {/* PHONE */}
                    <div className="col-6">

                      <label className="label-tiny">
                        Phone
                      </label>

                      <input
                        type="text"
                        name="phone"
                        placeholder="Phone"
                        className="form-control"
                        value={formData.phone}
                        onChange={handleChange}
                        required
                      />

                    </div>

                    {/* ADDRESS */}
                    <div className="col-6">

                      <label className="label-tiny">
                        Address
                      </label>

                      <input
                        type="text"
                        name="address"
                        placeholder="Address"
                        className="form-control"
                        value={formData.address}
                        onChange={handleChange}
                      />

                    </div>

                    {/* MESSAGE */}
                    <div className="col-12">

                      <label className="label-tiny">
                        Message
                      </label>

                      <textarea
                        className="form-control"
                        name="message"
                        placeholder="Enter your message..."
                        rows="4"
                        value={formData.message}
                        onChange={handleChange}
                        required
                      ></textarea>

                    </div>

                  </div>
                  {success && (
                    <div className="alert alert-success mt-3">
                      ✅ Message sent successfully! We will contact you shortly.
                    </div>
                  )}

                  {/* Error Message */}
                  {error && (
                    <div className="alert alert-danger mt-3">
                      ❌ {error}
                    </div>
                  )}
                  <button
                    type="submit"
                    className="send-btn mt-4"
                    disabled={loading}
                  >
                    {loading ? "Sending..." : "Send Message"}
                  </button>

                </form>

              </div>

            </div>

          </div>

        </div>

      </div>

      {/* Social Proof Section */}
      <section className="proof-section text-white">

        <div className="container text-center">

          <h2 className="proof-heading mb-5">
            Paab.in is the <i>Trusted</i> Platform since 2010 for Home Styling
          </h2>

          <div className="row g-4 mb-5">

            <div className="col-md-4">
              <div className="stat-number">10K</div>

              <p className="text-white-50">
                Making home styling simple and easy
              </p>
            </div>

            <div className="col-md-4">
              <div className="stat-number">2,000</div>

              <p className="text-white-50">
                Positive reviews from verified users
              </p>
            </div>

            <div className="col-md-4">
              <div className="stat-number">80</div>

              <p className="text-white-50">
                Expert consultants worldwide
              </p>
            </div>

          </div>

          <p className="achievement-tag">
            Some of our achievements
          </p>

        </div>

      </section>
    </>
  );
};

export default Contact;